import imgix from 'js/lib/imgix';

export const numToPx = (num: number) => `${Math.floor(num)}px`;
export const makeOptimizedImageUrl = (url: string, width: number) => imgix.processImage(url, { width });

export default { numToPx, makeOptimizedImageUrl };
